import React, { useState } from "react";
import { TextAreaWrapper, TextAreaField, CharCount } from "./style";

interface TextAreaProps {
  label?: string;
  labelColor?: string;
  field?: any;
  onBlur?: any;
  disabled?: boolean;
  readonly?: boolean;
  onChange?: (value: string) => void;
  placeholder?: string;
  classname?: string;
  hasError?: boolean;
  width?: string;
  rows?: number;
  maxLength?: number;
  showCount?: boolean;
  disableLabel?: boolean;
  value?: string;
  id?: string;
}

export const CustomTextArea = ({
  label,
  field,
  onBlur,
  onChange,
  disableLabel = false,
  readonly = false,
  labelColor,
  value,
  classname,
  hasError = false,
  disabled = false,
  width,
  rows = 5,
  maxLength = 200,
  showCount = true,
  id = "",
}: TextAreaProps) => {
  const [hasFocus, setHasFocus] = useState(false);

  const currentValue = field?.value || value || "";

  return (
    <TextAreaWrapper
      $labelColor={labelColor}
      $disabled={disabled}
      $width={width}
      $isReadonly={readonly}
      className={[
        classname || "",
        hasFocus ? "has-focus" : "",
        hasError ? "error" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onFocus={() => setHasFocus(true)}
      onBlur={() => setHasFocus(false)}
    >
      {!disableLabel && (
        <p
          className={`input-label ${hasFocus || hasError ? "top" : ""} ${
            currentValue?.length ? "top" : ""
          }`}
        >
          {label}
        </p>
      )}

      <TextAreaField
        id={id}
        placeholder={disableLabel ? label : ""}
        readOnly={readonly}
        disabled={disabled}
        rows={rows}
        maxLength={maxLength}
        onBlur={onBlur}
        {...field}
        value={currentValue}
        onChange={(e) => {
          field?.onChange?.(e);
          onChange?.(e.target.value);
        }}
        $disabled={disabled}
        $isReadonly={readonly}
      />

      {showCount && (
        <CharCount>
          {currentValue?.length ?? 0} / {maxLength}
        </CharCount>
      )}
    </TextAreaWrapper>
  );
};